module.exports = "/assets/site/images/sakk.jpg?c318321c2824a746e56810be02f73b1e";